export default "__VITE_ASSET__BSpa69kv__"